import React from 'react';


export default function() {
    return <>
        <p>Here’s a nice solution of Putnam 1981 B5 that I haven’t seen anywhere else (so far). The main idea is to sum `bitwise,' rather than `termwise.'</p>

        <p>Let \(S_k\) denote the set of positive integers with the {String.raw`\(k^{\text{th}}\)`} bit set, counting from the right starting at \(k=0\). Then we have</p>
        {String.raw`\[\sum_{n=1}^\infty \frac{B(n)}{n^2 + n} = \sum_{k=0}^\infty \sum_{n \in S_k} \frac{1}{n^2 + n}.\]`}
    </>;
}
